export const formatJPY = (value, opts = {}) => {
  const num = Number(value || 0);
  return new Intl.NumberFormat("ja-JP", {
    style: "currency",
    currency: "JPY",
    maximumFractionDigits: 0,
    ...opts,
  }).format(num);
};

export const formatNumber = (value) => {
  const num = Number(value || 0);
  return new Intl.NumberFormat("ja-JP", { maximumFractionDigits: 0 }).format(
    num
  );
};

export const formatDate = (s) => {
  if (!s) return "";
  try {
    const d = new Date(s);
    if (isNaN(d.getTime())) return s;
    return d.toLocaleDateString("ja-JP", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return s;
  }
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const addDaysISO = (days) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
};
